import { render, staticRenderFns } from "./PersonalChat.vue?vue&type=template&id=9215c2ec&"
import script from "./PersonalChat.vue?vue&type=script&lang=js&"
export * from "./PersonalChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports